module.exports = __webpack_public_path__ + "static/img/arrow-1.35fb4498.svg";